/**
 * Shared media stage + right-rail column sizing notes.
 *
 * The dialog shell owns explicit compact/focused heights (see FileDetailModal).
 * Stage + rail always fill that shell (`h-full` / `flex-1`) so expand/contract
 * morphs with the frame instead of jumping on mode change.
 *
 * Legacy tokens kept for any external references.
 */
export const FILE_DETAIL_COLUMN_HEIGHT_CLS = "h-full min-h-0";

/** @deprecated Prefer shell-driven fill; compact size is owned by the dialog. */
export const FILE_DETAIL_COLUMN_HEIGHT_FOCUSED_CLS = "h-full min-h-0";

/** Non-image FilePreview max height (fills stage). */
export const FILE_DETAIL_PREVIEW_MAX_HEIGHT_CLS = "max-h-full";

/** Shared right-rail panel header row (back + title). */
export const FILE_DETAIL_RAIL_HEADER_ROW_CLS =
  "flex shrink-0 items-center gap-1.5 pb-2.5";

/** Shared right-rail panel title typography. */
export const FILE_DETAIL_RAIL_HEADER_TITLE_CLS =
  "min-w-0 flex-1 truncate text-xl font-normal tracking-tight text-foreground";
